import { render, staticRenderFns } from "./accessControlList.vue?vue&type=template&id=909a935a&scoped=true"
import script from "./accessControlList.vue?vue&type=script&lang=js"
export * from "./accessControlList.vue?vue&type=script&lang=js"
import style0 from "./accessControlList.vue?vue&type=style&index=0&id=909a935a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909a935a",
  null
  
)

export default component.exports